import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useGetNewChatMobileContainerProperties } from "./useGetNewChatMobileContainerProperties";
import SelectChatWrapper from "../SelectChatWrapper/SelectChatWrapper.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewChatMobileContainer',
  setup(__props) {

const {
  lists,
  listsContainerHeight,
  handleRedirect,
  selectedGroupMembers,
  handleAddGroupMember,
  handleRemoveGroupMember,
  handleCreateChat,
  isRecommendationsVisible,
} = useGetNewChatMobileContainerProperties();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelectChatWrapper, {
    "lists-container-height": _unref(listsContainerHeight),
    lists: _unref(lists),
    "is-recommendations-visible": _unref(isRecommendationsVisible),
    "selected-members": _unref(selectedGroupMembers),
    title: _ctx.$t('chat.chatSidebar.NewChatPreview.title'),
    "confirm-title": _ctx.$t('settings.chat.createGroupChat.createGroup'),
    onAddSelected: _unref(handleAddGroupMember),
    onRemoveSelected: _unref(handleRemoveGroupMember),
    onRedirect: _unref(handleRedirect),
    onConfirm: _unref(handleCreateChat)
  }, null, 8, ["lists-container-height", "lists", "is-recommendations-visible", "selected-members", "title", "confirm-title", "onAddSelected", "onRemoveSelected", "onRedirect", "onConfirm"]))
}
}

})